// @flow
import { ApiBase } from 'api/api'
import {
  makeDeleteRequest,
  makePatchRequest,
  makePostRequest,
} from 'api/fetchCalls'
import type { RoutineType } from 'types/routines'

export async function createRoutine(
  customerId: string,
  data: RoutineType
): Promise<RoutineType> {
  return makePostRequest(`${ApiBase}/routines/${customerId}/`, {
    body: JSON.stringify(data),
  })
}

export async function updateRoutine(
  customerId: string,
  id: string,
  data: RoutineType
): Promise<RoutineType> {
  return makePatchRequest(`${ApiBase}/routines/${customerId}/${id}/`, {
    body: JSON.stringify(data),
  })
}

export async function deleteRoutine(
  customerId: string,
  id: string
): Promise<void> {
  return makeDeleteRequest(`${ApiBase}/routines/${customerId}/${id}/`)
}
